import { Box, Flex } from '@chakra-ui/react'
import { Outlet, useParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { LearnFooter } from './LearnFooter.js'
import { getBrand } from '../brand/index.js'

const BLOG_URL = import.meta.env.VITE_BLOG_URL || 'https://aicodingpatterns.com'

/**
 * Minimal chrome for the few Learn routes that must stay reachable WITHOUT a
 * session: certificate verification (third parties / employers) and invitation
 * landings (invitees who may not have an account yet). It carries the brand
 * (logo + footer) but no auth controls and no "log in" fallback — the logo
 * points at the public blog, never at the gated app.
 */
export function PublicShell() {
  const brand = getBrand()
  const { i18n } = useTranslation()
  const { lang } = useParams<{ lang: string }>()

  return (
    <Flex direction="column" minH="100vh">
      <Box
        as="header"
        position="sticky"
        top={0}
        zIndex={30}
        // Translucent "glass" bar to match the blog + LearnShell header.
        bg="rgba(255, 255, 255, 0.85)"
        backdropFilter="blur(14px) saturate(1.6)"
        borderBottomWidth="1px"
        borderColor="acp.line"
        h={{ base: '66px', md: '78px' }}
      >
        <Flex maxW="960px" mx="auto" px={4} h="100%" align="center">
          {/* Minimal-chrome logo points at the public blog, never the gated app. */}
          <a href={BLOG_URL} style={{ textDecoration: 'none', display: 'inline-flex', alignItems: 'center' }} aria-label={brand.name}>
            <img
              src={brand.assets.logo}
              alt={brand.name}
              width={200}
              height={28}
              style={{ height: '1.5rem', width: 'auto', display: 'block' }}
            />
          </a>
        </Flex>
      </Box>

      <Box flex={1} maxW="960px" mx="auto" w="100%" px={{ base: 0, md: 4 }} py={{ base: 2, md: 6 }}>
        <Outlet />
      </Box>

      <LearnFooter lang={lang || i18n.language} />
    </Flex>
  )
}
